// extracted by mini-css-extract-plugin
export var cartContainer = "_lw-4";
export var gray = "_lw-1";
export var itemContainer = "_lw-2";
export var itemDetails = "_lw-3";
export var strong = "_lw-0";